import { Alert, Button } from 'reactstrap';
import { layout } from '../NewHire/v2/styles';
import { AnnualReviewResponse } from './types';

interface PayRaiseDeclinedCardProps {
  review: AnnualReviewResponse;
  onResubmit: () => void;
  onContinue: () => void;
}

const PayRaiseDeclinedCard = ({ review, onResubmit, onContinue }: PayRaiseDeclinedCardProps) => {
  return (
    <div>
      <h1 style={{ ...layout.title, marginBottom: 4 }}>Pay Raise Declined</h1>
      <p style={layout.subtitle as any}>
        Finance declined the pay raise for {review.employeeName}. You can adjust the amount and resubmit it, or continue
        without a raise.
      </p>
      <Alert color="danger" className="mt-3">
        <i className="fas fa-circle-xmark mr-2" />
        {review.proposedPayRate?.decision?.deniedReason || 'No reason provided.'}
      </Alert>
      <div style={{ marginTop: 24, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <Button color="primary" onClick={onResubmit}>
          <i className="fas fa-rotate-right mr-2" />
          Resubmit pay raise
        </Button>
        <Button color="secondary" outline onClick={onContinue}>
          Continue without a raise
        </Button>
      </div>
    </div>
  );
};

export default PayRaiseDeclinedCard;
